import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import { MemberRole } from '~domain/MemberRole'
import { rvaiAuthApi } from '~services/api'


export const useMemberRolesStore = defineStore('memberRoles', () => {
  const state = reactive({
    roles: [] as MemberRole[],
  })

  const actions = {
    async loadMembersRoles (): Promise<void> {
      const { data } = await rvaiAuthApi.roles.listRoles()
      state.roles = data.items.map(MemberRole.fromResponse)
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...actions,
  }
})
